import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_THREAD_LIST_MEMBER_DETAILS = createAsyncActionTypes('FETCH_THREAD_LIST_MEMBER_DETAILS');